import { Component, OnChanges, ViewChild, ChangeDetectionStrategy, input, output } from '@angular/core';
import {UnitSelectionCandidate} from '../../model/unit-selection-candidate';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {EntityHeader} from '../../entity/entity-header';
import { SelectionCandidateDetailComponent } from '../selection-candidate-detail/selection-candidate-detail.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { PercentPipe } from '@angular/common';

@Component({
    selector: 'app-selection-candidate-grid',
    templateUrl: './selection-candidate-grid.component.html',
    styleUrls: ['./selection-candidate-grid.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    MatPaginator,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIconButton,
    MatIcon,
    MatSortHeader,
    MatTooltip,
    SelectionCandidateDetailComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    PercentPipe
]
})
export class SelectionCandidateGridComponent implements OnChanges {

  @ViewChild(MatSort, {static: true}) sort!: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  readonly notice = input.required<string>();
  readonly candidates = input.required<UnitSelectionCandidate[]>();
  readonly metricInput = input.required<boolean>();
  readonly addedToSchedule = output<UnitSelectionCandidate>();
  readonly datasource: MatTableDataSource<UnitSelectionCandidate> = new MatTableDataSource<UnitSelectionCandidate>();
  expandedElement!: UnitSelectionCandidate | null;
  displayColumns: string[] = ['details', 'add', 'model', 'size', 'width', 'depth', 'height', 'dryWeight', 'targetDeviation', 'costFactor'];

  ngOnChanges() {
    this.datasource.data = this.candidates();
    this.datasource.sort = this.sort;
    this.datasource.paginator = this.paginator;
    this.datasource.sortingDataAccessor = this.tableDataAccessor();
  }

  private tableDataAccessor(): (item: UnitSelectionCandidate, property: string) => any {
    return function (item: UnitSelectionCandidate, property: string): any {
      switch (property) {
        case 'model':
          return item.modelSizeCharacteristic.modelCode;
        case 'size':
          return item.modelSizeCharacteristic.sizeCode;
        case 'width':
          return item.modelSizeCharacteristic.width;
        case 'depth':
          return item.modelSizeCharacteristic.depth;
        case 'height':
          return item.modelSizeCharacteristic.height;
        case 'nominalCfm':
          return item.modelSizeCharacteristic.nominalCfm;
        case 'dryWeight':
          return item.modelSizeCharacteristic.dryWeight;
        default:
          return (item as unknown as Record<string, unknown>)[property];
      }
    };
  }

  getImageFileName(candidate: UnitSelectionCandidate): string {
    return candidate?.modelSizeCharacteristic?.ratingsModel?.imageFileName || '';
  }

  addToSchedule(candidate: UnitSelectionCandidate): void {
    this.addedToSchedule.emit(candidate);
  }

  isSureflow(candidate: UnitSelectionCandidate): boolean {
    return candidate?.modelSizeCharacteristic?.ratingsModel?.sureFlowModel;
  }

}
